import React from "react";
import { Container } from "react-bootstrap";

export default function AboutBanner({ data }) {
  return (
    <section className="Museums-main position-relative">
      <img
        src={data?.image?.link || "images/Community-banner.png"}
        className="banner_inner"
      />
      <div className="overlay-gra"></div>
      <Container>
        <div className="banner-head">
          <h1>{data?.topHeading || ""}</h1>
        </div>
      </Container>
    </section>
  );
}
